module.exports = __webpack_public_path__ + "img/style-after.24c6609f.webp";